import { createSelector } from 'reselect';

const selectHelpTopicsFiles = (state: any) => state.helpTopicsFiles;


export const selectHelpTopicsFilesCurrentItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.current);

export const selectHelpTopicsFilesListItems = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.list);

export const selectHelpTopicsFilesItemById = (itemId: any) =>
    createSelector(selectHelpTopicsFilesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectHelpTopicsFilesQueryItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.query);

export const selectHelpTopicsFilesCreatedItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.create);

export const selectHelpTopicsFilesUpdatedItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.update);

export const selectHelpTopicsFilesReadItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.read);

export const selectHelpTopicsFilesDeletedItem = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.delete);

export const selectHelpTopicsFilesSearchedItems = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.search);

export const selectHelpTopicsFilesItemsCount = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.count);

export const selectHelpTopicsFilesItemsFilter = createSelector([selectHelpTopicsFiles], (helpTopicsFiles) => helpTopicsFiles.filter);